import React from 'react';

export const Settings = () => (
  <g transform="scale(54)" strokeWidth="0.01851852">
    <path
      fill="#748498"
      strokeWidth="0.01851852"
      d="m 11,17 v 3 H 9 v -3 z m 7,-5 v 8 H 16 V 12 Z M 4,7 V 20 H 2 V 7 Z M 18,0 v 7 h 2 v 3 H 14 V 7 h 2 V 0 Z m -7,0 v 12 h 2 v 3 H 7 V 12 H 9 V 0 Z M 4,0 V 2 H 6 V 5 H 0 V 2 H 2 V 0 Z"
    />
  </g>
);
